export default __webpack_public_path__ + "static/media/jeanette-profile1.7c1b0126.png";